import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { catchError, filter, finalize, map, switchMap, take, } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
import { UserFactory } from './user.factory';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private authService: AuthenticationService,
    private userFactory: UserFactory,
    private translate: TranslateService
  ) {}

  setHeader(req: HttpRequest<any>, token: string): HttpRequest<any> {
    const headers = {
      'Accept-Language': this.translate.currentLang === 'th' ? 'th-TH' : 'en-EN',
      'Access-Control-Allow-Origin': '*',
      'Expires': '-1',
      'Pragma': 'no-cache',
      'Cache-Control': 'no-store, no-cache, must-revalidate',
      'X-XSS-Protection': '1',
      'X-Content-Type-Options': 'nosniff',
      'Strict-Transport-Security': 'max-age=3600',
      'ApiVersion': '1',
    // ,'Content-Type': 'application/json',
      // 'Expires': '-1',
      // 'Pragma': 'no-cache, no-store, must-revalidate'
    };
    if (token) {
      headers['Authorization'] = environment.authorizationPrefix + token;
    }
    req = req.clone({ setHeaders: headers });


    return req;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<| HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
    | any> {
    return next
    .handle(this.setHeader(req, this.authService.getAuthToken()))
    .pipe(map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //console.log('event', event);
        }
        return event;
      }), catchError(err => {
        if (err instanceof HttpErrorResponse) {
          switch ((<HttpErrorResponse>err).status) {
            case 401:
              return this.handle401Error(req, next);
            case 400:
              return <any>this.authService.logout();
          }
        } else {
          return throwError(err);
        }
      })
    );
  }

  handle400Error(error) {
    if (
      error &&
      error.status === 400 &&
      error.error &&
      error.error.error === 'invalid_grant'
    ) {
      // If we get a 400 and the error message is 'invalid_grant', the token is no longer valid so logout.
      return throwError('');
    }

    return throwError(error);
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((user: any) => {
          if (user) {
            this.tokenSubject.next(user.token);
            this.userFactory.saveTokenAndProfile(user.token, user.profile);
            return next.handle(this.setHeader(request, user.token));
          }

          return <any>this.authService.logout();
        }),
        catchError(err => {
          return <any>this.authService.logout();
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        })
      );
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject.pipe(filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.setHeader(request, token));
        }));
    }
  }
}
